import { Component, OnInit, Input } from '@angular/core';
import { AppSecuredComponent } from 'src/app/app-secured/app-secured.component';
import { ChangePasswordComponent } from '../../../app-secured/dialog-genaral/change-password/change-password.component';
import { environment } from 'src/environments/environment';
import { SelectModel } from '../../models/entity/Selected.model';
import { AuthService } from '../../services/api/auth.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Constant } from '../../infrastructure/constant';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styles: [
  ]

})

export class TopbarComponent implements OnInit {

  envir = environment;
  activeItem: number;
  // Data
  hubs: SelectModel[] = [];
  //
  selectedHubs: any;
  searchText = '';
  ref: DynamicDialogRef;
  fullName: string;

  constructor(
    public app: AppSecuredComponent,
    private authService: AuthService,
    protected dialogService: DialogService,
  ) { }

  ngOnInit(): void {
   this.fullName = localStorage.getItem(Constant.auths.fullName);
    // this.user.fullName = this.authService.getFullName();
  }

  mobileMegaMenuItemClick(index): void {
    this.app.megaMenuMobileClick = true;
    this.activeItem = this.activeItem === index ? null : index;
  }

  changePassword(item: any = null): void {
    this.ref = this.dialogService.open(ChangePasswordComponent, {
      header: `${  'Đổi mật khẩu'}`,
      width: '25%',
      contentStyle: { 'max-height': '500px', overflow: 'inherit' },
      styleClass: 'dialog-user',
      baseZIndex: 10000,
      data: item,
    });
    this.ref.onClose.subscribe((res: any) => {
    });
  }

  // personalInformation(item: any = null): void {
  //   this.ref = this.dialogService.open(PersonalInformationComponent, {
  //     header: `${ 'Thông tin cá nhân' }`,
  //     width: '50%',
  //     contentStyle: { 'max-height': '500px', overflow: 'inherit' },
  //     styleClass: 'dialog-user',
  //     baseZIndex: 10000,
  //     data: item,
  //   });
  //   this.ref.onClose.subscribe((res: any) => {
  //   });
  // }

  logout(): void {
    this.authService.logout();
  }


}
